import ApiService from '@/common/api.service'

import {
  CREATE_STREAMER,
  GET_STREAMERS,
  GET_USERS,
  UPDATE_USER_STATUS,
  RESET_USER_STATE,
  GET_STREAMER,
  UPDATE_STREAMER,
  CREATE_EDITOR,
  GET_USER,
  UPDATE_USER,
  GET_BANNED_USERS
} from './actions.type'
import {
  SET_ERROR,
  SET_STREAMERS,
  SET_CREATED_STREAMER,
  SET_USERS,
  SET_IS_LOADING,
  RESET_STATE,
  SET_STREAMER,
  SET_UPDATED_STREAMER,
  SET_EDITORS,
  SET_EDITOR,
  SET_BANNED_USERS
} from './mutations.type'

import Progress from '@/common/progress'

export const getDefaultState = () => {
  return {
    streamers: null,
    streamer: null,
    users: null,
    bannedUsers: [],
    editor: null,
    editors: null,
    totalStreamerPage: 0,
    totalUserPage: 0,
    totalBannedUserPage: 0,
    totalEditorPage: 0,
    profileUrl: '',
    isLoading: false,
    error: null
  }
}

const state = getDefaultState()

const getters = {
  totalStreamerPage(state) {
    return state.totalStreamerPage
  },
  streamers(state) {
    return state.streamers
  },
  totalUserPage(state) {
    return state.totalUserPage
  },
  users(state) {
    return state.users
  },
  bannedUsers(state) {
    return state.bannedUsers
  },
  totalBannedUserPage(state) {
    return state.totalBannedUserPage
  }
}

const actions = {
  [CREATE_STREAMER](context, streamer) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/streamers', streamer)
        .then((response) => {
          if (response.data) {
            context.commit(SET_CREATED_STREAMER, response.data)
            resolve(response.data)
          } else {
            context.commit(SET_ERROR, response)
            reject(response)
          }
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  async [CREATE_EDITOR](context, editor) {
    try {
      context.commit(SET_IS_LOADING, true)
      const res = await ApiService.post('api/v1/register', editor)
      context.commit(SET_CREATED_STREAMER, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  [GET_STREAMERS](context, page) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamers/admin', '?limit=10&page=' + page)
        .then(({ data }) => {
          context.commit(SET_STREAMERS, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response)
          reject(response)
        })
    })
  },
  [GET_STREAMER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamers', id).then(({ data }) => {
        context.commit(SET_STREAMER, data)
        resolve(data)
      }).catch(({ response }) => {
        context.commit(SET_ERROR, response)
        reject(response.data)
      })
    })
  },
  [UPDATE_STREAMER](context, streamer) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put('api/v1/streamers/updateStreamer', streamer)
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_UPDATED_STREAMER, data)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [GET_USERS](context, { role, page, query }) {
    var url = `?role=${role}&status=active&limit=10&page=${page}`
    if (query) {
      url += `&query=${query}`
    }
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/users', url)
        .then(({ data }) => {
          if (role === 'user') {
            context.commit(SET_USERS, data)
          } else {
            context.commit(SET_EDITORS, data)
          }
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response)
          reject(response)
        })
    })
  },
  [GET_BANNED_USERS](context, {page, query, streamerId}) {
    var url = `?status=disabled&limit=10&page=${page}`
    if (streamerId) {
      url += `&bannedBy=${streamerId}`
    }
    if (query) {
      url += `&query=${query}`
    }
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/users', url)
        .then(({ data }) => {
          context.commit(SET_BANNED_USERS, data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response)
          reject(response)
        })
    })
  },
  [UPDATE_USER_STATUS](context, { id, status }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put(`api/v1/users/${id}/updateStatus`, { status: status })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_IS_LOADING, false)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  async [GET_USER](context, id) {
    try {
      const res = await ApiService.get('api/v1/users', id)
      context.commit(SET_EDITOR, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  async [UPDATE_USER](context, { id, user }) {
    context.commit(SET_IS_LOADING, true)
    try {
      const res = await ApiService.put(`api/v1/users/${id}`, user)
      context.commit(SET_IS_LOADING, false)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  [RESET_USER_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_STREAMERS](state, streamerResponse) {
    state.streamers = streamerResponse.data
    state.streamer = null
    state.totalStreamerPage = streamerResponse.meta.lastPage
    state.isLoading = false
  },
  [SET_STREAMER](state, streamer) {
    state.streamer = streamer
    state.isLoading = false
    state.error = null
  },
  [SET_UPDATED_STREAMER](state) {
    state.streamer = null
    state.isLoading = false
    state.error = null
  },
  [SET_USERS](state, userResponse) {
    state.users = userResponse.data
    state.totalUserPage = userResponse.meta.lastPage
    state.error = null
  },
  [SET_BANNED_USERS](state, response) {
    state.bannedUsers = response.data
    state.totalBannedUserPage = response.meta.lastPage
    state.error = null
  },
  [SET_EDITORS](state, response) {
    state.editors = response.data
    state.totalEditorPage = response.meta.lastPage
    state.error = null
  },
  [SET_CREATED_STREAMER](state, streamerResponse) {
    state.profileUrl = ''
    state.streamer = null
    state.isLoading = false
    state.error = null
  },
  [SET_EDITOR](state, response) {
    state.editor = response
    state.error = null
    state.isLoading = false
  },
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading
    state.error = null
  },
  [SET_ERROR](state, error) {
    state.error = error
    state.isLoading = false
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
